<template>
  <b-card no-body v-draggable 
          class="lead-mgmt-popup"
          :style="{ 'width': `${popupWidth}px`, 'max-width': '100vw' }"
          >
    <b-card-header  class="lead-mgmt-popup-header"
                    header-tag="div"
                    header-bg-variant="dark">
      <div>
        <strong>{{ title }}</strong>
      </div>
      <font-awesome-icon  class="cx-close-icon mx-1 clickable" 
                          :icon="['far', 'times']"
                          @click="$emit('close')" />
    </b-card-header>
    <slot>
      <div class="dummy-content">Popup content ...</div>
    </slot>
  </b-card>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Header empty ...' },
    popupWidth: { type: Number, default: 1024 }
  }
}
</script>

<style scoped>
  .lead-mgmt-popup {
    box-shadow: 3px 3px 13px -3px var(--border-color-secondary);
    border: 1px solid var(--border-color-secondary);
    border-radius: var(--border-radius-popup);
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 600px;
    min-height: 25vh !important;
    max-height: calc(100vh - 90px);
  }
  .lead-mgmt-popup div:nth-child(2) {
    overflow: auto;
  }

  .lead-mgmt-popup-header {
    border-radius: var(--border-radius-popup) var(--border-radius-popup) 0px 0px !important;
    display: grid;
    grid-template-columns: 1fr auto; 
    color: lightgrey; 
    padding: 0.25rem 0.5rem!important;
    height: 32px; 
    text-align: left;
  }

  .dummy-content {
    padding: 40% 40%;
  }
</style>